import React, { useState } from "react"
import { createPortal } from "react-dom"
import { Grid } from "@mui/material"

import { BATCH_ROUTES } from "@constants"
import PageWrapper from "../../@PageWrapper"
import BatchTable from "./Table"
import BatchDetailsDrawer from "./Modal"
import VirtualTourButton, { TourOverlay, TOUR_STEPS } from './VirtualTour'
import BatchDemoData from './VirtualTour/DemoData'
import { isTourDemoActive } from '@signals/app'


export default function BatchPage() {
	const [tourActive, setTourActive] = useState(false)

	return <PageWrapper
		head={`DS Rentacar | ${BATCH_ROUTES.TITLE}`}
		title={BATCH_ROUTES.TITLE}
		subtitle={BATCH_ROUTES.SUBTITLE}
		actions={<VirtualTourButton onClick={() => { setTourActive(true); isTourDemoActive.value = true }} />}
	>
		<Grid container>
			<Grid item xs={12}>
				<BatchTable/>
			</Grid>
			<Grid item xs={12}>
				<BatchDetailsDrawer/>
			</Grid>
		</Grid>
		{tourActive && <BatchDemoData />}
		{tourActive && createPortal(
			<TourOverlay steps={TOUR_STEPS} onClose={() => { setTourActive(false); isTourDemoActive.value = false }} />,
			document.body
		)}
	</PageWrapper>
}